const projects = [
  {
    id: "APIC-2411-0142",
    title: "EV Battery Enclosure v2",
    status: "In Production",
    statusColor: "bg-blue-100 text-blue-700",
    tag: "EV",
    centre: "APIC Visakhapatnam",
    eta: "Nov 28",
    stage: "Manufacturing",
    progress: 62,
  },
  {
    id: "APIC-2411-0138",
    title: "Agri Drone Chassis",
    status: "Inspection",
    statusColor: "bg-cyan-100 text-cyan-700",
    tag: "Drone",
    centre: "APIC Vijayawada",
    eta: "Nov 22",
    stage: "Quality Inspection",
    progress: 88,
  },
  {
    id: "APIC-2411-0129",
    title: "IoT Smart Water Sensor",
    status: "Awaiting Approval",
    statusColor: "bg-orange-100 text-orange-700",
    tag: "IoT / PCB",
    centre: "APIC Tirupati",
    eta: "Dec 06",
    stage: "Quotation",
    progress: 25,
  },
  {
    id: "APIC-2411-0117",
    title: "Medical Infusion Housing",
    status: "Review",
    statusColor: "bg-orange-100 text-orange-700",
    tag: "Medical",
    centre: "APIC Visakhapatnam",
    eta: "Dec 12",
    stage: "CAD Review",
    progress: 15,
  },
  {
    id: "APIC-2410-0098",
    title: "Smart Helmet Shell",
    status: "Completed",
    statusColor: "bg-green-100 text-green-700",
    tag: "Wearable",
    centre: "APIC Kurnool",
    eta: "Delivered Oct 18",
    stage: "Delivered",
    progress: 100,
  },
  {
    id: "APIC-2410-0083",
    title: "Solar Charge Controller Case",
    status: "Completed",
    statusColor: "bg-green-100 text-green-700",
    tag: "Electronics",
    centre: "APIC Vijayawada",
    eta: "Delivered Oct 05",
    stage: "Delivered",
    progress: 100,
  },
  {
    id: "APIC-2409-0071",
    title: "Robotic Gripper Fingers",
    status: "Completed",
    statusColor: "bg-green-100 text-green-700",
    tag: "Robotics",
    centre: "APIC Visakhapatnam",
    eta: "Delivered Sep 22",
    stage: "Delivered",
    progress: 100,
  },
];

export default projects;